import { FC, useState } from "react";
import { format } from "date-fns";
import { Box, Tooltip } from "@mui/material";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers-pro";
import {
  AddBoxOutlined as AddBoxOutlinedIcon,
  DeleteOutlineRounded as DeleteOutlineRoundedIcon,
} from "@mui/icons-material";
import __ from "src/utils/Translations";
import findInExcludedDays from "src/utils/Company/Absences/findInExcludedDays";
import {
  CalendarAction,
  IExcludedDay,
} from "src/Pages/Company/Absences/Calendars/Calendars.models";
import { getPickerStyles } from "./CalendarPicker.styles";

interface ICustomCalendarDayProps extends PickersDayProps {
  excludedDays: IExcludedDay[];
  excludedWeekDays: number[];
  handleCalendarDayAction: (action: CalendarAction, day: Date) => void;
}

const CustomCalendarDay: FC<ICustomCalendarDayProps> = ({
  excludedDays = [],
  excludedWeekDays = [],
  handleCalendarDayAction,
  ...props
}) => {
  const { day } = props;
  const [action, setAction] = useState(false);
  const excluded = findInExcludedDays(day, excludedDays);
  const isExcluded = !!excluded && excluded.label;
  const isExcludedWeekday = excludedWeekDays.includes(day.getDay());

  const actionButton = isExcluded ? (
    <DeleteOutlineRoundedIcon />
  ) : (
    <AddBoxOutlinedIcon />
  );

  return (
    <PickersDay
      {...props}
      onMouseEnter={() => setAction(true)}
      onMouseLeave={() => setAction(false)}
      onDaySelect={() =>
        handleCalendarDayAction(
          isExcluded ? CalendarAction.DELETE : CalendarAction.ADD,
          day
        )
      }
      sx={getPickerStyles(!!isExcluded, isExcludedWeekday)}
      data-testid="absences-calendar-picker-day"
    >
      {action ? (
        <Tooltip
          title={__(
            isExcluded ? `Usuń ${excluded.label}` : "Dodaj dzień wolny"
          )}
          placement="top"
          arrow
        >
          <Box
            component="span"
            color="white"
            data-testid="absences-calendar-picker-action"
          >
            {actionButton}
          </Box>
        </Tooltip>
      ) : (
        format(day, "d")
      )}
    </PickersDay>
  );
};

export default CustomCalendarDay;
